jQuery(function(){

  //remove comportamento do menu default do estadão
  var landing_page = jQuery('.single-landing_page');
  var post_patrocinado = jQuery('.single-post_patrocinado');
  if(landing_page.length > 0 || post_patrocinado.length > 0){
    jQuery('.jc-estadao-bar-adjustment').removeClass();
    jQuery('.jc-nav-wrapper').removeClass();
  }

  //dispara evento de facebook contact ao clicar no icone de chat do whatsapp
  var chatWhatsapp = jQuery('.jc-lp-chat-button');

  if ( chatWhatsapp.length > 0 ){

    chatWhatsapp.click(function(){

      dataLayer.push({
        'event': 'fbqTrackContact'
      });

    });

  }

  //adiciona evento de mostrar form qndo user chega no fim da page
  scrollEndPageShowFormEvent(jQuery);

  var lastId,
  menu          = jQuery('#landing-page-menu .smooth-scroll'),
  menuHeight    = 51;

  if (menu.length > 0) {
    var navbarHeight  = menu.find('.navbar').height(),
    menuItens     = menu.find('a'),
    menuPosition   = menu.offset().top,
    scrollItems   = menuItens.map(function(){
      var item    = jQuery(jQuery(this).attr("data-target"));
      if(item.length){ return item; }
    });

        //Menu scroll animation

        menuItens.click(function(event) {
          event.preventDefault();
          var id  = jQuery(this).attr("data-target");
          var target  = jQuery(id);

          if (target.length > 0) {
            jQuery('html, body').animate({
              scrollTop: (target.offset().top - navbarHeight)
            }, 800);
          }
        });

        //Movendo o scroll com base no hash da url

        var hash = jQuery(window.location.hash);

        if (hash.length) {
          scrollTo(jQuery(hash));
        }

        stickyMenu(jQuery(window).scrollTop());

        jQuery(window).on('scroll', function(event) {
          event.preventDefault();
          var scrollPosition = jQuery(this).scrollTop();
          stickyMenu(scrollPosition, menuPosition);
          changeActiveMenu(scrollPosition);
        });

      }


  //Change menu

  function changeActiveMenu(scrollPosition) {

    var fromTop = scrollPosition + navbarHeight + 15;

    var cur = scrollItems.map(function(){
      if (jQuery(this).offset().top < fromTop)
        return this;
    });

    var id = cur && cur.length ? cur[cur.length-1].attr('id') : "";

    if (lastId !== id) {
      lastId = id;

      menuItens.removeClass('active');
      menu.find("[data-target='#"+id+"']").addClass('active');
    }
  }

  //Sticky menu

  function stickyMenu(scrollPosition, menuPosition) {

    var fixed = false;

    if (scrollPosition >= menuPosition) {
      fixed = true;
    }

    if (fixed) {
      menu.addClass('fixed-top');
      jQuery('body').css('margin-top', menuHeight);
    } else {
      menu.removeClass('fixed-top');
      jQuery('body').css('margin-top', 0);
    }
  }


  //Slider
  jQuery('.jc-banner-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    fade: true,
    autoplay: false,
    adaptiveHeight: true,
    responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
      }
    }
    ]
  });

  jQuery('.jc-image-slider').slick();

  /**
   * Ativa galeria de imagens
   */

  jQuery('.jc-gallery-photo').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    fade: true,
    autoplay: false,
    adaptiveHeight: true
  });

  /**
   * Ativa galeria de imagens no mobile para grid de imagens
   */
  jQuery(window).on('load resize orientationchange', function(){
    jQuery('.jc-lp-image-gallery-grid').each(function(){
      var $carousel = $(this);
      if($(window).width() > 1000) {
        if($carousel.hasClass('slick-initialized')) {
          $carousel.slick('unslick');
        }
      } else {
        if(!$carousel.hasClass('slick-initialized')) {
          $carousel.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            fade: true,
            autoplay: false,
            adaptiveHeight: true
          });
        }
      }
    });
  });

  /**
   * Ativa galeria de vídeos
   */
  jQuery('.jc-gallery-video').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.jc-gallery-video-nav'
  });

  jQuery('.jc-gallery-video-nav').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.jc-gallery-video',
    dots: false,
    focusOnSelect: true,
    responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        slidesToShow: 3
      }
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        slidesToShow: 3
      }
    }
    ]
  });

});


//
//
//Bottom form bar

var formBottomBar = jQuery('.jc-bottom-form-bar');
var formHeaderBar = jQuery('.jc-bottom-form-bar-header');
var formBodyBar = jQuery('.jc-bottom-form-bar-body');
var formHeaderBarHeight = formHeaderBar.height();
var button = jQuery('.jc-bottom-form-bar').find('.btn-bottom-form-bar');
var buttonLabel = formBottomBar.find('.btn-bottom-form-bar').text();
var formShowCount = 1;


function getScrollBarWidth() {
  var inner = document.createElement('p');
  inner.style.width = "100%";
  inner.style.height = "200px";

  var outer = document.createElement('div');
  outer.style.position = "absolute";
  outer.style.top = "0px";
  outer.style.left = "0px";
  outer.style.visibility = "hidden";
  outer.style.width = "200px";
  outer.style.height = "150px";
  outer.style.overflow = "hidden";
  outer.appendChild (inner);

  document.body.appendChild (outer);
  var w1 = inner.offsetWidth;
  outer.style.overflow = 'scroll';
  var w2 = inner.offsetWidth;
  if (w1 === w2) {
    w2 = outer.clientWidth;
  }

  document.body.removeChild (outer);

  return (w1 - w2);
}

function showFormBottom() {
  if (formBottomBar.length > 0) {
    formHeaderBar.css("padding-right", getScrollBarWidth());
    formBodyBar.css("padding-right", getScrollBarWidth());
    formBottomBar.addClass('show');
    jQuery('body').addClass('modal-open').css("padding-right", getScrollBarWidth());
    jQuery(button).text('Fechar').removeClass('btn-primary').addClass('btn-outline-secondary');
    formShowCount++;
  }
}

function hideFormBottom() {
  if (formBottomBar.length > 0) {
    formHeaderBar.css("padding-right", 0);
    formBodyBar.css("padding-right", 0);
    formBottomBar.removeClass('show');
    jQuery('body').removeClass('modal-open').css("padding-right", 0);
    jQuery(button).text(buttonLabel).removeClass('btn-outline-secondary').addClass('btn-primary');
  }
}

//Conta exibição do form para o modal

jQuery('#contentFormModal').on('shown.bs.modal', function (e) {
  formShowCount++;
});


//Adicona margem ao body

if (formHeaderBar.length > 0) {
  jQuery('body').css('margin-bottom', formHeaderBarHeight);
}


//Ative o form com clique
jQuery('.btn-bottom-form-bar').click(function(event) {
  event.preventDefault();

  if(jQuery(".jc-posts").length == 0){
    clickEventModalFormLandingPage(jQuery(this).text());
  } else{
    clickEventModalFormPostLandingPage(jQuery(this).text());
  }

  if (!formBottomBar.hasClass('show')) {
    showFormBottom();
  } else {
    hideFormBottom();
  }
});

//Mostra o form quando o usuário chega pela primeira vez no rodapé da página
function scrollEndPageShowFormEvent(jQuery){
  jQuery(window).scroll(function() {

    if(jQuery(window).scrollTop() + jQuery(window).height() == jQuery(document).height() && formShowCount == 1) {
      showFormBottom();
    }
  });
}


